module.exports = __webpack_public_path__ + "static/img/updateInfo.1c990764.png";